import { devError } from "../../utils/devConsole";

const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '2df0eb35-10e0-4d1c-aef3-baad59e84a11';
const tenantId = process.env.REACT_APP_MICROSOFT_TENANT_ID || 'common';
const authority = `https://login.microsoftonline.com/${tenantId}`;

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
    // Configurazione per forzare la scadenza dopo 1 minuto
    secureCookies: false,
  },
  system: {
    // Configurazione per gestire la scadenza dei token
    tokenRenewalOffsetSeconds: 30, // Rinnovare 30 secondi prima della scadenza
    loadFrameTimeout: 10000,
    iframeHashTimeout: 10000,
    windowHashTimeout: 60000,
  },
};

if (!msalConfig.auth.clientId || !msalConfig.auth.authority) {
  devError('Missing MSAL configuration values');
}
